import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/lost/sign/init', method: 'GET', params }, { interceptResultCode: false });
};

// 领取奖励
export const rewardAPI = (params) => {
  return axios({ url: '/lost/sign/reward', method: 'POST', params }, { interceptResultCode: false });
};




// WEBPACK FOOTER //
// ./src/pages/mitu/special/api.js